import {SaveChangesRef} from "components/src/common/SaveChangesRef";
import {useTranslationWithOverride} from "components/src/hook/UseTranslationWithOverride";
import {SettingsLevel} from "components/src/settings/SettingsUtils";
import {useRef, useState} from "react";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import {DLPSelection} from "./DLPSelection";

export const DLPSystemSelection = () => {
    /**
     * A reference to a component with a saveSettings method which is used to save changes when the save button is clicked
     */
    const saveChangesRef = useRef<SaveChangesRef>();
    /**
     * If set, settings should be saved
     */
    const [shouldSave, setShouldSave] = useState<boolean>(false);
    /**
     * Set to true while saving to show a spinner on the download button
     */
    const [saving, setSaving] = useState<boolean>(false);

    /**
     * i18next translation hook
     */
    const {t} = useTranslationWithOverride();

    const saveButton = (
        <Button variant="success"
                type="submit"
                onClick={() => saveChangesRef.current?.saveChanges()}
                disabled={!shouldSave}>
            {saving && <Spinner
                as="span"
                animation="border"
                size="sm"
                aria-hidden="true"
                className="me-1"
            />}
            {saving ? t("common.saving") : t("common.save")}
        </Button>
    );

    return (
        <DLPSelection settingsLevel={SettingsLevel.System}
                      settingsLevelSubSelector=""
                      setShouldSave={setShouldSave}
                      ref={saveChangesRef}
                      setSaving={setSaving}
                      saveButton={saveButton}/>
    )
}
